import React from 'react';
import PropTypes from 'prop-types';
import {observer, inject} from 'mobx-react';
import {observable, makeObservable} from 'mobx';
import $ from 'jquery';

import VideoModal from '../modals/video-modal';
import {utilsService} from '../../core/services/utils.service';
import EditDeleteButtons from '../edit-delete-buttons/edit-delete-buttons';


@inject('store')
@observer
export default class Video extends React.Component {

  static propTypes = {
    store: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    fileName: PropTypes.string,
    image: PropTypes.string,
    imageAltText: PropTypes.string,
    lengthInSeconds: PropTypes.number,
    caption: PropTypes.string,
    keywords: PropTypes.string,
    sectionId: PropTypes.number.isRequired,
    isInEditMode: PropTypes.bool
  }

  static defaultProps = {
    fileName: '',
    image: '',
    imageAltText: ''
  }

  constructor(props) {
    super(props);
    makeObservable(this);
    this.AblePlayer = null;
    this.videoSrc = utilsService.getFilePath(this.props.fileName);
    this.captionFile = utilsService.getFilePath(this.props.caption);
    this.posterFile = utilsService.getFilePath(this.props.image);
  }

  componentWillUnmount() {
    this.videoModal.hideModal();
  }

  @observable showTranscript = false;
  @observable hasLoaded = false;
  @observable hasError = false;

  toggleTranscript = () => {
    this.showTranscript = !this.showTranscript;
  }

  onVideoCardClick = () => {
    if (!this.hasError) {
      this.launchModal();
    }
  }

  onVideoCardKeydown = (event) => {
    if (!this.hasError) {
      const keyDown = (window.Event)
        ? event.which
        : event.keyCode;
      if (keyDown === 13) {
        this.launchModal();
      }
    }
  }

  launchModal = () => {
    this.trackModalOpen();
    utilsService.tagLinkItem(this.props.title, 'Video Click', 'training.firstnet.att.com');
    this.videoModal.showModal();
    this.setUp();
  }

  trackModalOpen = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'event': 'videoModalOpen', 'videoTitle': this.props.title});
  }

  handleHideModal = () => {
    if (this.AblePlayer) {
      this.showTranscript = false;
      this.AblePlayer.pauseMedia();
    }
  }

  setUp = () => {
    if (!this.AblePlayer) {
      this.trackVideoLifecycle();
      this.initializeAblePlayer()
    } else {
      this.AblePlayer.reinitialize();
    }
  }

  trackVideoLifecycle = () => {
    setTimeout(() => {
      let video = document.getElementById(this.props.id);
      video.src = this.videoSrc;

      video.onloadstart = () => {
        console.debug('video ' + this.props.fileName + ' loadstart');
      };

      video.oncanplay = () => {
        console.debug('video ' + this.props.fileName + ' canplay');
      };

      video.oncanplaythrough = () => {
        console.debug('video ' + this.props.fileName + ' canplaythrough');
        this.hasLoaded = true;
      }

      video.onerror = () => {
        console.debug('video ' + this.props.fileName + ' error');
        utilsService.tagMediaItem(this.props.title, 'Video_Error_Display');
      }

      video.onended = () => {
        console.debug('video ' + this.props.fileName + ' ended');
        utilsService.tagMediaItem(this.props.title, 'Video_Update');
      }

      video.onplay = () => {
        console.debug('video ' + this.props.fileName + ' play');
        utilsService.tagMediaItem(this.props.title, 'Video_Commence');
      }

      video.load();
    }, 0);
  }

  initializeAblePlayer = () => {

    if (!this.AblePlayer) {
      Promise.resolve(new AblePlayer($(`#${this.props.id}`))).then(player => {
        this.AblePlayer = player;
        //setTimeout to ensure the whole player is in the DOM.
        setTimeout(() => {

          //FPSE-2351: Fullscreen on iOS tablets not working correctly, this shim extends iOS support
          //Copied over AblePlayer setFullScreen method (https://github.com/ableplayer/ableplayer/blob/master/scripts/control.js) and overwriting here with iOS specific changes so that we don't have to fork our own version of Ableplayer.
          this.AblePlayer.setFullscreen = function(fullscreen) {

            //For iOS, fullscreen requests should be made on the video tag and not its wrapper
            var isIOSDevice = this.isIOS();
            var thisObj = this;
            var $el = thisObj.$ableWrapper;
            var el = (isIOSDevice)
              ? thisObj.media
              : $el[0];

            if (this.nativeFullscreenSupported() || isIOSDevice) {

              if (fullscreen) {
                this.preFullScreenWidth = this.$ableWrapper.width();
                this.preFullScreenHeight = this.$ableWrapper.height();

                if (el.requestFullscreen) {
                  el.requestFullscreen();
                } else if (isIOSDevice) {
                  // On iOS we want to call enterFullScreen on the media, not its wrapper
                  el.webkitEnterFullscreen();
                } else if (el.webkitRequestFullscreen) {
                  el.webkitRequestFullscreen();
                } else if (el.mozRequestFullScreen) {
                  el.mozRequestFullScreen();
                } else if (el.msRequestFullscreen) {
                  el.msRequestFullscreen();
                }
              } else {
                if (document.exitFullscreen) {
                  document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                  document.webkitExitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                  document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
                }
              }
              $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', function() {
                if (!thisObj.isFullscreen()) {
                  thisObj.restoringAfterFullScreen = true;
                  thisObj.resizePlayer(thisObj.preFullScreenWidth, thisObj.preFullScreenHeight);
                }
              });
            } else {
              // Non-native fullscreen support through modal dialog.
              // Create dialog on first run through.
              if (!this.fullscreenDialog) {
                var $dialogDiv = $('<div>');
                // create a hidden alert, communicated to screen readers via aria-describedby
                var $fsDialogAlert = $('<p>',{
                  'class': 'able-screenreader-alert'
                }).text(this.tt.fullscreen); // In English: "Full screen"; TODO: Add alert text that is more descriptive
                $dialogDiv.append($fsDialogAlert);
                // now render this as a dialog
                this.fullscreenDialog = new AccessibleDialog($dialogDiv, this.$fullscreenButton, 'dialog', 'Fullscreen video player', $fsDialogAlert, this.tt.exitFullScreen, '100%', true, function () { thisObj.handleFullscreenToggle() });
                $('body').append($dialogDiv);
              }

              // Track whether paused/playing before moving element; moving the element can stop playback.
              var wasPaused = this.isPaused();

              if (fullscreen) {
                this.modalFullscreenActive = true;
                this.fullscreenDialog.show();

                // Move player element into fullscreen dialog, then show.
                // Put a placeholder element where player was.
                this.$modalFullscreenPlaceholder = $('<div class="placeholder">');
                this.$modalFullscreenPlaceholder.insertAfter($el);
                $el.appendTo(this.fullscreenDialog.modal);

                // Column left css is 50% by default; set to 100% for full screen.
                if ($el === this.$ableColumnLeft) {
                  $el.width('100%');
                }
                var newHeight = $(window).height() - this.$playerDiv.height();
                if (!this.$descDiv.is(':hidden')) {
                  newHeight -= this.$descDiv.height();
                }
                this.resizePlayer($(window).width(), newHeight);
              } else {
                this.modalFullscreenActive = false;
                if ($el === this.$ableColumnLeft) {
                  $el.width('50%');
                }
                $el.insertAfter(this.$modalFullscreenPlaceholder);
                this.$modalFullscreenPlaceholder.remove();
                this.fullscreenDialog.hide();
                this.resizePlayer(this.$ableWrapper.width(), this.$ableWrapper.height());
              }
              // Resume playback if moving stopped it.
              if (!wasPaused && this.isPaused()) {
                this.playMedia();
              }
            }
            this.refreshControls();
          };

          this.AblePlayer.prefTabbable = 1;
          this.AblePlayer.updatePrefs();

          $(`#${this.props.id}`).prev('.able-big-play-button').prepend('<span class="sr-only">Play video</span>');

          this.AblePlayer.$autoScrollTranscriptCheckbox.remove();
        }, 100);
      });
    }
  }

  renderVideoElement = () => {
    let styles = {};
    if (!this.hasLoaded) {
      /* It's important to use visibility instead of display, so that the
      video element loads into the DOM and begins processing the src field. */
      styles = {
        visibility: 'hidden',
        height: '0'
      }
    }
    return (
      <div style={styles}>
        <video
          ref={(ref) => this.videoRef = ref}
          id={this.props.id}
          data-transcript-div={`${this.props.id}-transcript`}
          preload="auto"
          data-root-path=""
          poster={this.posterFile}
          data-speed-icons="animals"
          data-use-transcript-button="false"
          data-use-descriptions-button="false"
          data-icon-type="font"
          width="100%"
          type="video/mp4">
          <track kind="captions" src={this.captionFile} />
        </video>
      </div>
    )
  }

  renderDuration = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = totalSeconds - minutes * 60;
    const paddedSeconds = new Array(3).join('0' + remainingSeconds).slice(-2);
    return `${minutes}:${paddedSeconds}`;
  }

  renderIconOverlay = () => {
    if (this.hasError) {
      return (
        <i className="icon-filmstrip-off" aria-hidden="aria-hidden">
          <span className="icon-filmstrip-off__text">
            Video failed to load.
          </span>
        </i>
      )
    }
    return <i className="icon-play-circle" aria-hidden="aria-hidden"></i>
  }

  renderTranscriptToggle = () => {
    if (!this.hasError && Boolean(this.captionFile)) {
      return (
        <div className="transcript-toggle-button">
          <button
            className="fn-inverse"
            aria-haspopup="true"
            aria-expanded={this.showTranscript}
            onClick={this.toggleTranscript}>
            {`${this.showTranscript
              ? 'Close'
              : 'Open'} Transcript`
            }
          </button>
        </div>
      )
    }
    return '';
  }

  renderTranscript = () => {
    //The wrapper must persist in order to be located by jQuery
    const display = `${this.showTranscript
      ? 'block'
      : 'none'}`;
    return (
      <div
        id={`${this.props.id}-transcript`}
        className={'col-12 transcript-wrapper'}
        style={{ display}} />
      );
  }

  renderSummaryCard = () => {
    const backgroundImage = !this.hasError && this.posterFile
      ? `url("${this.posterFile}")`
      : 'none';
    return (
      <React.Fragment>
        <div
          className="video-item__poster"
          style={{backgroundImage}}>
          {this.renderIconOverlay()}
        </div>
        <div className="video-item__body">
          <div className="sr-only">
            {
              this.hasError
                ? 'Video failed to load.'
                : 'Click to view video,'
            }
          </div>
          <h3>{this.props.title}</h3>
          <div className="duration">
            <div className="sr-only">Video duration</div>
            {this.renderDuration(this.props.lengthInSeconds)}
          </div>
          <div className="description">
            <p>{this.props.description}</p>
          </div>
        </div>
      </React.Fragment>
    )
  }

  renderLoadingAnimation = () => {
    return (
      <div
        className="fn-loading"
        role="status"
        aria-busy={true}
        aria-labelledby="vid-loading-title">
        <h1 id="vid-loading-title" className="fn-loading-text">Loading Video</h1>
        <div className="fn-loading-circle" aria-hidden={true}>
          {[...Array(12)].map((x, i) => <div key={i} className={`c${i + 1} c`}></div>)}
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="video-wrapper">
        {this.props.isInEditMode && <EditDeleteButtons
          contentId={this.props.id}
          sectionId={this.props.sectionId}
          title={this.props.title}
          align="left" />}
        <div
          role="button"
          tabIndex="0"
          onClick={this.onVideoCardClick}
          onKeyDown={this.onVideoCardKeydown}
          className="video-item card">
          {this.renderSummaryCard()}
        </div>
        <VideoModal
          id={`${this.props.id}-video-modal`}
          ref={(ref) => this.videoModal = ref}
          onHideModal={this.handleHideModal}>
          {!this.hasError && this.renderVideoElement()}
          {this.hasLoaded
            ? this.renderTranscriptToggle()
            : this.renderLoadingAnimation()
          }
          {this.renderTranscript()}
        </VideoModal>
      </div>
    )
  }
}
